import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PhoneRequestPage.css";
import config from "../config/config";

const PhoneRequestPage = () => {
    const [phone, setPhone] = useState("+998"); // сразу с префиксом
    const navigate = useNavigate();

    const handleChange = (e) => {
        let value = e.target.value;

        // если пользователь пытается удалить +998 → не даем
        if (!value.startsWith("+998")) {
            value = "+998" + value.replace(/\D/g, "");
        }

        // разрешаем только цифры после +998
        const onlyNums = "+998" + value.slice(4).replace(/\D/g, "");

        // ограничиваем максимум 13 символов (+998 + 9 цифр)
        setPhone(onlyNums.slice(0, 13));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(
                `${config.apiUrl2}/api/orders/obratno-vizov`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "User-Agent": "insomnia/11.3.0",
                    },
                    body: JSON.stringify({ phoneNumber: phone }),
                }
            );

            if (response.ok) {
                alert("✅ Заявка успешно отправлена! Мы скоро вам перезвоним.");
                navigate("/"); // переход на главную
            } else {
                alert("❌ Ошибка при отправке. Попробуйте снова.");
            }
        } catch (error) {
            console.error("Ошибка:", error);
            alert("⚠️ Сервер недоступен. Попробуйте позже.");
        }
    };

    return (
        <div className="phone-page">
            {/* Кнопка закрытия */}
            <button className="close-btn" onClick={() => navigate("/")}>
                ✖ CLOSE
            </button>

            <div className="form-container">
                <h2 className="title">Оставьте телефон — мы позвоним вам 📞</h2>
                <form onSubmit={handleSubmit}>
                    <label className="label">Телефон:</label>
                    <input
                        type="tel"
                        value={phone}
                        onChange={handleChange}
                        className="phone-input"
                        required
                    />
                    <button type="submit" className="submit-btn">
                        Отправить
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PhoneRequestPage;
